import CruiseDynamicFilter from "./CruiseDynamicFilter";

export const cruiseDynamicFilter = {
    init: (domElement) => {
        if (domElement) {
            const resultContainer = domElement.querySelector("#dynamicFilter");
            new CruiseDynamicFilter(domElement, resultContainer)
        }
    },
}

export default cruiseDynamicFilter;